import React from 'react'
import NotificationLanding from '../../components/notification/NotificationLanding'
import HelmetWrapper from '../../HelmetWrapper'

const Notification = () => {
  return (
    <HelmetWrapper title="WTF: Notification">
      <NotificationLanding />
    </HelmetWrapper>
  )
}

export default Notification